var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdgeBerryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m173.1 26.232v390.43h73.087v-390.43h-73.087zm-83.213 131.05v177.24h73.086v-177.24h-73.086zm-82.842 27.988v177.24h73.088v-177.24h-73.088zm249.61 78.821v177.24h73.086v-177.24h-73.086zm164.61 13.371v177.24h73.088v-177.24h-73.088zm-82.363 22.334v177.24h73.088v-177.24h-73.088z",
    fill: "#0007ff",
    strokeLinecap: "round",
    strokeWidth: 1.8898
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBerryLogo);
export default __webpack_public_path__ + "static/media/EdgeBerry_logo.3b77a9c4cf91f1d31f741d87686ae297.svg";
export { ForwardRef as ReactComponent };